import SongSettings from '~/routes/SingASong/SongSelection/Components/SongSettings/SongSettings';

export default SongSettings;
